import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const texturesWordList = [
  "aluminum",
  "bark",
  "brass",
  "brick",
  "bronze",
  "canvas",
  "clay",
  "cloth",
  "cold",
  "concrete",
  "cool",
  "copper",
  "cotton",
  "damp",
  "dry",
  "dust",
  "fiber",
  "foam",
  "glass",
  "gold",
  "grain",
  "hard",
  "hot",
  "ink",
  "iron",
  "layer",
  "moist",
  "mud",
  "paint",
  "paper",
  "plastic",
  "powder",
  "rock",
  "rough",
  "rust",
  "sand",
  "silk",
  "silver",
  "smooth",
  "soft",
  "soil",
  "steel",
  "sticky",
  "string",
  "texture",
  "warm",
  "wet",
  "wire",
  "wood",
  "wooden",
  "wool",
];

export const texturesCollection: WordCollection = createCollection(
  "textures",
  "Textures & Materials",
  texturesWordList,
  { icon: "texture-box", isWordlistViewable: true },
);
